import validate from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.15.21_eslint@9.27.0_rollup@4.41.0_sass-embedded@1.89.0_sass@_b79de274a22d692d3638a8396f725fe9/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.15.21_eslint@9.27.0_rollup@4.41.0_sass-embedded@1.89.0_sass@_b79de274a22d692d3638a8396f725fe9/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-to-landing-page": () => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/middleware/redirect-to-landing-page.ts")
}